export default "__VITE_ASSET__MJ0WUT0a__"